(() => {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');

  if (menuToggle && mobileNav) {
    const closeMenu = () => {
      menuToggle.setAttribute('aria-expanded', 'false');
      menuToggle.setAttribute('aria-label', 'Open menu');
      mobileNav.hidden = true;
      document.body.classList.remove('menu-open');
    };
    menuToggle.addEventListener('click', () => {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      menuToggle.setAttribute('aria-label', isOpen ? 'Open menu' : 'Close menu');
      mobileNav.hidden = isOpen;
      document.body.classList.toggle('menu-open', !isOpen);
    });
    mobileNav.addEventListener('click', (event) => {
      if (event.target.closest('a')) closeMenu();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !mobileNav.hidden) {
        closeMenu();
        menuToggle.focus();
      }
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    const form = select.closest('form');
    if (!form) return;
    const price = form.parentElement?.querySelector('[data-variant-price]');
    const addButton = form.querySelector('[data-add-button]');

    const updateVariant = () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (addButton) {
        const available = option.dataset.available === 'true';
        addButton.disabled = !available;
        addButton.textContent = available ? 'Add to bag' : 'Sold out';
      }
    };

    select.addEventListener('change', updateVariant);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-moment-toggle]');
    if (!button) return;
    const details = document.getElementById(button.getAttribute('aria-controls'));
    const card = button.closest('.moment-card');
    if (!details || !card) return;
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    button.setAttribute('aria-label', `${expanded ? 'Read more about' : 'Close details for'} ${card.querySelector('.moment-card__heading h3')?.textContent?.trim() || 'this use case'}`);
    details.hidden = expanded;
    card.classList.toggle('is-expanded', !expanded);
  });

  const revealTargets = document.querySelectorAll('.section, .story-section, .faq-section, .newsletter-section, .spotlight, .moments, .steps');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    revealTargets.forEach((target) => {
      target.classList.add('reveal-ready');
      observer.observe(target);
    });
  }
})();
